function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useReducer } from 'react';
import { ConfirmationModal, Typography } from 'seagull';
import { useOverlayContext } from "../../contexts";
import { useOnMount } from "../useOnMount";
import styles from "./useBulkActionModal.module.scss";
import { Checkmark, CloseLiner24 } from 'seagull/icons';
import pluralize from "../../utils/pluralize";
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
function reducer(state, action) {
  switch (action.type) {
    case 'succeeded':
      return _objectSpread(_objectSpread({}, state), {}, {
        succeeded: state.succeeded + 1
      });
    case 'failed':
      return _objectSpread(_objectSpread({}, state), {}, {
        failed: state.failed.add(action.failedId),
        errors: action.error != null ? state.errors.concat(action.error) : state.errors
      });
  }
}
function BulkActionModal(props) {
  const {
    bulkItemIds,
    progressTitle,
    progressAction = 'Sending',
    actionName,
    itemName,
    errorExtra,
    dismissModal,
    canProcessItem,
    processSingleItem,
    getErrorText
  } = props;
  const [state, dispatch] = useReducer(reducer, {
    succeeded: 0,
    failed: new Set([]),
    errors: []
  });
  useOnMount(() => {
    async function sendSingleRequest(itemId) {
      try {
        if (canProcessItem(itemId)) {
          const result = await processSingleItem(itemId);
          if (result.success) {
            dispatch({
              type: 'succeeded'
            });
          } else {
            dispatch({
              type: 'failed',
              failedId: itemId,
              error: getErrorText ? getErrorText(itemId, result.error) : typeof result.error === 'string' && result.error || null
            });
          }
        } else {
          dispatch({
            type: 'succeeded'
          });
        }
      } catch (err) {
        dispatch({
          type: 'failed',
          failedId: itemId,
          error: null
        });
      }
    }
    bulkItemIds.reduce((asyncChain, itemId) => asyncChain.then(() => sendSingleRequest(itemId)), Promise.resolve());
  });
  const closeModal = () => dismissModal(Array.from(state.failed.values()));
  return /*#__PURE__*/_jsx(ConfirmationModal, {
    title: progressTitle,
    textAlignCenter: false,
    width: "680px",
    content: /*#__PURE__*/_jsxs("div", {
      children: [state.succeeded + state.failed.size < bulkItemIds.length ? /*#__PURE__*/_jsxs(Typography, {
        children: [progressAction, " ", pluralize(itemName, bulkItemIds.length), " (", state.succeeded + state.failed.size, "/", bulkItemIds.length, ")"]
      }) : /*#__PURE__*/_jsxs(_Fragment, {
        children: [state.succeeded > 0 && /*#__PURE__*/_jsxs("div", {
          className: styles.bulkRequestsResultSuccess,
          children: [/*#__PURE__*/_jsx(Checkmark, {}), ' ', /*#__PURE__*/_jsxs(Typography, {
            skin: "success",
            "data-testid": "bulk-succeeded-text",
            children: [pluralize(itemName, state.succeeded, true), " ", actionName, " successfully"]
          })]
        }), state.failed.size > 0 && /*#__PURE__*/_jsxs("div", {
          className: styles.bulkRequestsResultFailure,
          children: [/*#__PURE__*/_jsx(CloseLiner24, {}), ' ', /*#__PURE__*/_jsxs(Typography, {
            skin: "error",
            "data-testid": "bulk-failed-text",
            children: [pluralize(itemName, state.failed.size, true), " could not be ", actionName, errorExtra != null ? " ".concat(errorExtra) : '']
          })]
        }), state.errors.length > 0 && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(Typography, {
            style: {
              marginTop: '16px',
              marginBottom: '16px'
            },
            "data-testid": "bulk-failed-details",
            children: "Details:"
          }), /*#__PURE__*/_jsx("ul", {
            style: {
              marginLeft: '12px'
            },
            children: state.errors.map((error, index) => /*#__PURE__*/_jsx("li", {
              style: {
                listStyle: 'disc'
              },
              children: /*#__PURE__*/_jsx(Typography, {
                children: error
              })
            }, index))
          })]
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: styles.progressBarBackground
      })]
    }),
    primaryButtonLabel: "Close",
    cancelButtonDisabled: bulkItemIds.length != state.succeeded + state.failed.size,
    primaryButtonDisabled: bulkItemIds.length != state.succeeded + state.failed.size,
    onPrimaryButtonClick: closeModal,
    onCloseButtonClick: closeModal
  });
}
export function useBulkActionModal() {
  const overlayContext = useOverlayContext();
  async function doBulkAction(props) {
    const {
      confirmation,
      onConfirmed,
      onDone
    } = props;
    const confirmed = await overlayContext.showModal({
      content: p => confirmation.renderModal ? confirmation.renderModal(p) : /*#__PURE__*/_jsx(ConfirmationModal, {
        title: confirmation.title,
        textAlignCenter: false,
        content: confirmation.content,
        primaryButtonLabel: confirmation.primaryButtonLabel,
        secondaryButtonLabel: "Cancel",
        onPrimaryButtonClick: () => p.dismissModal(true),
        onSecondaryButtonClick: () => p.dismissModal(false)
      })
    });
    if (!confirmed) {
      return;
    }
    onConfirmed && onConfirmed();
    const failedItemIds = await overlayContext.showModal({
      content: p => /*#__PURE__*/_jsx(BulkActionModal, _objectSpread(_objectSpread({}, props), p))
    });
    onDone(failedItemIds);
  }
  return {
    doBulkAction
  };
}